import PropTypes from 'prop-types';
import { useCallback, useMemo } from 'react';
import Message from '../../../components/Message';
import { useOrderContext } from '../../../providers/OrderProvider';
import OrderFullscreenModal from '../../dashboard/processing-order/modal/common/OrderFullscreenModal';
import OrderFullscreenModalBody from '../../dashboard/processing-order/modal/common/OrderFullscreenModalBody';
import OrderDetailModalBody from '../../dashboard/processing-order/modal/common/OrderDetailModalBody';
import { OrderDetailViewOnlyProvider } from '../../dashboard/processing-order/modal/common/OrderDetailViewOnlyContext';
import OrderModalFooter from '../../dashboard/processing-order/modal/common/OrderModalFooter';
import OrderModalHeader from '../../dashboard/processing-order/modal/common/OrderModalHeader';

/** 只读订单详情。审批、发货、收款等操作留在各自的待办弹框里。 */
const OrderDetailModal = ({ setIsOpenModal, isOpenModal, badgeTrack = 'default', className, backdropClassName }) => {
	const { order, isLoading, isError, orderDetailsError, currentOrderOId } = useOrderContext();
	const { orderId, customerInfo, approvalStatus, isCompleted } = order ?? {};
	const hasOrderForCurrent = Boolean(order?._id && currentOrderOId && String(order._id) === String(currentOrderOId));
	const showLoadError = isError && !hasOrderForCurrent;
	const loadErrorMessage =
		orderDetailsError?.data?.message || orderDetailsError?.error || '无法加载订单详情，您可能无权查看该订单。';

	const handleClose = useCallback(() => {
		setIsOpenModal(false);
	}, [setIsOpenModal]);

	const orderStatusBadge = useMemo(() => {
		const badges = order?.uiHints?.modalStatusBadges;
		if (!badges) return null;
		if (badgeTrack === 'delivery') return badges.delivery ?? null;
		if (badgeTrack === 'payment') return badges.payment ?? null;
		return badges.default ?? null;
	}, [order, badgeTrack]);

	return (
		<OrderFullscreenModal show={isOpenModal} onHide={handleClose} className={className} backdropClassName={backdropClassName}>
			<OrderModalHeader
				orderId={orderId}
				customerInfo={customerInfo}
				isLoading={isLoading}
				isCompleted={isCompleted}
				approvalStatus={approvalStatus}
				badges={orderStatusBadge ? [orderStatusBadge] : []}
			/>
			<OrderFullscreenModalBody isLoading={isLoading}>
				{showLoadError ? (
					<Message variant='danger' className='my-4'>
						{loadErrorMessage}
					</Message>
				) : (
					<OrderDetailViewOnlyProvider value>
						<OrderDetailModalBody notesType='pay' />
					</OrderDetailViewOnlyProvider>
				)}
			</OrderFullscreenModalBody>
			<OrderModalFooter />
		</OrderFullscreenModal>
	);
};

OrderDetailModal.propTypes = {
	setIsOpenModal: PropTypes.func.isRequired,
	isOpenModal: PropTypes.bool.isRequired,
	badgeTrack: PropTypes.oneOf(['default', 'delivery', 'payment']),
	className: PropTypes.string,
	backdropClassName: PropTypes.string,
};

export default OrderDetailModal;
